import React from 'react'
import styles from './styles/common-competitors.module.scss'
import i18n from 'constants/strings'
import { Player } from 'types/global'
import { Flag } from 'components/generic/Country'
import { getProfileUrl, isPlayerHidden } from 'utils'
import OptedOutPlayer from 'components/profile/generic/OptedOutPlayer'

const arrow = (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='#DADCE0'
      fillOpacity='.52'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    />
    <path
      stroke='#16234C'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M9.9 7.5l4.8 4.5-4.8 4.5'
    />
  </svg>
)

interface Props {
  players: [Player, Player]
  tableData: any
  visibleCompetitorsInCommon: number
  totals: {
    p1TotalWinPc: number
    p2TotalWinPc: number
    p1TotalWin: number
    p1TotalLoss: number
    p2TotalWin: number
    p2TotalLoss: number
  }
  setVisibleCompetitorsInCommon: React.Dispatch<React.SetStateAction<number>>
}

const H2HCommonCompetitorsDesktop: React.FC<Props> = ({
  players,
  tableData,
  visibleCompetitorsInCommon,
  totals,
  setVisibleCompetitorsInCommon,
}) => {
  return (
    <div className={styles.mobile}>
      {tableData.slice(0, visibleCompetitorsInCommon).map(c => {
        return (
          <table key={c.id}>
            <thead>
              <tr>
                <th>
                  {isPlayerHidden(c) ? (
                    <OptedOutPlayer player={c} />
                  ) : (
                    <>
                      <a href={getProfileUrl(c.id)} className={styles.nameLink}>
                        <Flag alpha3={c.countryCode} />
                        <span className={styles.competitorName}>{`${c.firstName.charAt(0)}. ${
                          c.lastName
                        }`}</span>
                        <span className={styles.wtnRating}>{`(${
                          c.wtnSingles ||
                          (typeof c.wtnSingles === 'string' && c.isRanked
                            ? i18n.t('strData.pro')
                            : i18n.t('strData.na'))
                        })`}</span>
                      </a>
                      <a href={getProfileUrl(c.id)}>{arrow}</a>
                    </>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.players}>
                <td className={styles.player1}>{players[0].fullName}</td>
                <td className={styles.player2}>{players[1].fullName}</td>
              </tr>
              <tr className={` ${styles.winLossHeader}`}>
                <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</td>
                <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</td>
              </tr>
              <tr className={`${styles.statValue} ${styles.paddingBottom}`}>
                <td>{`${c.p1Loss}-${c.p1Win}`}</td>
                <td>{`${c.p2Loss}-${c.p2Win}`}</td>
              </tr>
              <tr className={styles.winLossHeader}>
                <td className={`${styles.statHeader}`}>
                  {i18n.t('strCommonCompetitors.winPercent')}
                </td>
                <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winPercent')}</td>
              </tr>
              <tr className={styles.statValue}>
                <td>{`${c.p1WinPc}%`}</td>
                <td>{`${c.p2WinPc}%`}</td>
              </tr>
            </tbody>
          </table>
        )
      })}
      <table className={styles.totalsMobile}>
        <thead>
          <tr>
            <th>{i18n.t('strCommonCompetitors.totals')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.players}>
            <td className={styles.player1}>{players[0].fullName}</td>
            <td className={styles.player2}>{players[1].fullName}</td>
          </tr>
          <tr className={` ${styles.winLossHeader}`}>
            <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</td>
            <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winLoss')}</td>
          </tr>
          <tr className={`${styles.statValue} ${styles.paddingBottom}`}>
            <td>{`${totals.p1TotalLoss}-${totals.p1TotalWin}`}</td>
            <td>{`${totals.p2TotalLoss}-${totals.p2TotalWin}`}</td>
          </tr>
          <tr className={styles.winLossHeader}>
            <td className={`${styles.statHeader}`}>{i18n.t('strCommonCompetitors.winPercent')}</td>
            <td className={styles.statHeader}>{i18n.t('strCommonCompetitors.winPercent')}</td>
          </tr>
          <tr className={styles.statValue}>
            <td>{`${totals.p1TotalWinPc}%`}</td>
            <td>{`${totals.p2TotalWinPc}%`}</td>
          </tr>
        </tbody>
      </table>
      {tableData.length > visibleCompetitorsInCommon && (
        <div className={styles.btnWrapper}>
          <button
            className={styles.showMoreBtn}
            onClick={() => {
              setVisibleCompetitorsInCommon(visibleCompetitorsInCommon + 10)
            }}
          >
            {i18n.t('strCommonCompetitors.showMore')}
          </button>{' '}
        </div>
      )}
    </div>
  )
}

export default H2HCommonCompetitorsDesktop
